<template>
  <div>
    <h3>{{ familyName }}</h3>
    <input
      :id="topCheckboxId"
      ref="indeterminateCb"
      type="checkbox"
      indeterminate
      @change="e => onIndeterminateChange(e)"
    />
    <label :for="topCheckboxId">Select All</label>
    <div v-for="radio in radios" :key="getRadioId(radio)">
      <input
        :id="getRadioId(radio)"
        v-model="checkedNames"
        type="checkbox"
        :value="`${radio.productId}`"
        @change="onChange()"
      />
      <label :for="getRadioId(radio)">
        {{ radio.alias || radio.name }}
      </label
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    checked: {
      type: Array,
      default: () => []
    },
    groupName: {
      type: String,
      default: ''
    },
    familyName: {
      type: String,
      default: ''
    },
    radios: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return { checkedNames: this.checked };
  },
  computed: {
    topCheckboxId() {
      return `${this.groupName}${this.familyName}`;
    },
    radiosLength() {
      return this.radios.length;
    },
    allNames() {
      return this.radios.map(radio => radio.productId);
    },
    checkedNamesLength() {
      return this.checkedNames.length;
    }
  },
  mounted() {
    this.onChange();
  },
  methods: {
    getRadioId(radio) {
      return `${this.groupName}${this.familyName}${radio.productId}`;
    },
    onIndeterminateChange(e) {
      if (e && e.target.checked) {
        this.checkedNames = this.allNames;
      } else {
        this.checkedNames = [];
      }
      this.$emit('checked-changed', this.checkedNames);
    },
    onChange() {
      if (
        this.checkedNamesLength > 0 &&
        this.radiosLength !== this.checkedNamesLength
      ) {
        this.$refs.indeterminateCb.indeterminate = true;
      } else {
        this.$refs.indeterminateCb.indeterminate = false;
      }
      this.$refs.indeterminateCb.checked =
        this.radiosLength === this.checkedNamesLength;
      this.$emit('checked-changed', this.checkedNames);
    },
    selectAll() {
      this.$refs.indeterminateCb.checked = true;
      this.checkedNames = this.allNames;
      this.$emit('checked-changed', this.allNames);
    },
    reset() {
      this.$refs.indeterminateCb.indeterminate = false;
      this.$refs.indeterminateCb.checked = false;
      this.checkedNames = [];
      this.$emit('checked-changed', this.checkedNames);
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '~@eds/vanilla/variables/global.less';
@import '../assets/common.less';

label {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
h3 {
  font-size: @font-size-lg;
  margin-bottom: @space-base;
}
.product-name:before {
  content: '\A';
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin: 0 @space-base 0 @space-small;
  display: inline-block;
  background: #212121;
}
.product-name.capacity:before {
  background: @orange-50;
}
.product-name.compact:before {
  background: @green-35;
}
.product-name.coverage:before {
  background: @blue-43;
}
</style>
